import axios from 'axios';
import { AxiosQueryProps, TokenType } from 'model/types/auth.js';

const axiosServices = axios.create({ baseURL: import.meta.env.VITE_TRENDIO_API_URL ?? 'http://localhost:3010/' });

export default axiosServices;

export const tokenAuthenticatedPost = async ({ query, vars }: AxiosQueryProps) => {
  const response = await axiosServices.post(import.meta.env.VITE_TRENDIO_API_URL, { query, variables: vars });
  return response.data;
};

// This function takes 3 args: TokenType defines the Auth method (Bearer, JWT). A key is needed,
// a value is optional. If the value is not provided, the key will be removed from localStorage.
export const setSession = (type: TokenType, tokenKey: string, tokenValue?: string | null) => {
  if (tokenKey && tokenValue && type) {
    localStorage.setItem(tokenKey, tokenValue);
    axiosServices.defaults.headers.common.Authorization = `${type} ${tokenValue}`;
  } else {
    localStorage.removeItem(tokenKey);
    delete axiosServices.defaults.headers.common.Authorization;
  }
};
